import { render, staticRenderFns } from "./OpenSongLibraryButton.vue?vue&type=template&id=4520d398&scoped=true&"
import script from "./OpenSongLibraryButton.vue?vue&type=script&lang=ts&"
export * from "./OpenSongLibraryButton.vue?vue&type=script&lang=ts&"
import style0 from "./OpenSongLibraryButton.vue?vue&type=style&index=0&id=4520d398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4520d398",
  null
  
)

export default component.exports